// extracted by mini-css-extract-plugin
export default {"title":"J--z","warning":"K--z","sizeOptionsLegendText":"L--z"};